import { useState } from 'react'
import { CalendarBlank } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../ModalContainer/ModelContainer'
import API from '../../../api/api'

const GOOGLE_SYNC_CALENDAR_TYPE = 'google'
const OUTLOOK_SYNC_CALENDAR_TYPE = 'outlook'

const SyncCalendar = () => {
  const { t } = useTranslation(['calendar'])
  const [openModal, setOpenModal] = useState(false)
  const [isLoading, setIsLodaing] = useState(false)
  const fetchAuthUrl = (type) => async () => {
    try {
      setIsLodaing(true)
      const {
        data: { authUrl },
      } = await API.syncCalendar(type)
      if (authUrl) {
        window.location.href = authUrl
      }
    } catch (err) {
      console.error(err)
    } finally {
      setIsLodaing(false)
    }
  }

  return (
    <div className="sync-calendar">
      <button className="ctp-sidebar-button" onClick={() => setOpenModal(true)}>
        <CalendarBlank size={20} />
        {t('calendar:syncCalendar.sync')}
      </button>
      <ModalContainer
        isVisible={openModal}
        additionalClass="sync-calendar-modal"
        headerIcon={<CalendarBlank size={32} />}
        headerTitle={t('calendar:syncCalendar.syncTitle')}
        onClose={() => setOpenModal(false)}
      >
        <div className="modal-container">
          <p className="modal-container-description">{t('calendar:syncCalendar.description')}</p>
          <div className="choose-calendar">
            <h4 className="choose-calendar-title">{t('calendar:syncCalendar.chooseService')}</h4>
            <div className="choose-calendar-buttons">
              <button
                onClick={fetchAuthUrl(GOOGLE_SYNC_CALENDAR_TYPE)}
                className="ctp-sidebar-button"
                disabled={isLoading}
              >
                {t('calendar:syncCalendar.googleCalendar')}
              </button>
              <button
                onClick={fetchAuthUrl(OUTLOOK_SYNC_CALENDAR_TYPE)}
                className="ctp-sidebar-button"
                disabled={isLoading}
              >
                {t('calendar:syncCalendar.outlookCalendar')}
              </button>
            </div>
          </div>
        </div>
      </ModalContainer>
    </div>
  )
}

export default SyncCalendar
